import { GeneralPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const suppliesSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Shipping rules");
      },
      permission: GeneralPermissions.OTHER,
    },
    path: "supplies/shipping-rules",
    lazy: async () => {
      const { SuppliesShippingFlowBuilder } =
        await import("../../../../setting/redo-supplies/shipping-rules/supplies-shipping-flow-builder");
      return { Component: SuppliesShippingFlowBuilder };
    },
  },
];
